// // src/components/Reusablesteps/Resolvelifestage.js
// //
// // Reads from:
// //   womenhealth.json  — full life stage definitions + entryReasons (rich version)
// //   agedata.json      — ageMaritalToLifeStages mapping + entryReasons (alternate)
// //
// // We use womenhealth.json as the PRIMARY source since it has
// // both ageMaritalToLifeStages AND entryReasons in one file.

// import WOMEN_HEALTH from "../../womenhealth.json";

// const { ageMaritalToLifeStages, entryReasons, lifeStages, lifeStageEmoji } = WOMEN_HEALTH;

// // ── Normalizers ──────────────────────────────────────────────────────────────

// // const AGE_MAP = {
// //   "18–25": "18–25", "18-25": "18–25",
// //   "26–35": "26–35", "26-35": "26–35",
// //   "36–45": "36–45", "36-45": "36–45",
// //   "46–55": "46–55", "46-55": "46–55",
// //   "56+":   "56+",
// // };

// const AGE_MAP = {
//   "10–14 years": "18–25",
//   "15–19 years": "18–25",
//   "20–25 years": "18–25",
//   "26–35 years": "26–35",
//   "36–45 years": "36–45",
//   "46–55 years": "46–55",
//   "55–64 years": "56+",
//   "65+ years":   "56+",
// };

// const MARITAL_ALLOWED = ["Single", "Married", "Divorced", "Prefer not to say"];

// export const normalizeAge     = (raw = "") => AGE_MAP[raw?.trim()] || null;
// export const normalizeMarital = (raw = "") =>
//   MARITAL_ALLOWED.includes(raw) ? raw : "Prefer not to say";

// // ── Core stage resolver ──────────────────────────────────────────────────────

// /**
//  * getLifeStages(age, marital)
//  * Looks up womenhealth.json → ageMaritalToLifeStages
//  * Returns array of stage keys e.g. ["adolescence", "youngAdult"]
//  */
// export function getLifeStages(age, marital) {
//   const ageKey     = normalizeAge(age);
//   const maritalKey = normalizeMarital(marital);
//   if (!ageKey) return ["youngAdult"];
//   const byAge = ageMaritalToLifeStages[ageKey] || {};
//   return (
//     byAge[maritalKey] ||
//     byAge["Prefer not to say"] ||
//     ["youngAdult"]
//   );
// }

// // ── Entry reasons ────────────────────────────────────────────────────────────

// /**
//  * getEntryReasons(stages)
//  * Returns journey object { journeyTitle, screenTitle, options[] }
//  * for the primary (first) stage key from womenhealth.json → entryReasons
//  */
// export function getEntryReasons(stages = []) {
//   const primary = stages[0] || "youngAdult";
//   return entryReasons[primary] || entryReasons["youngAdult"];
// }

// // ── Life stage metadata ──────────────────────────────────────────────────────

// /**
//  * getLifeStageMeta(stageKey)
//  * Returns { emoji, color } for a stage key from womenhealth.json → lifeStageEmoji
//  */
// export function getLifeStageMeta(stageKey) {
//   return lifeStageEmoji?.[stageKey] || { emoji: "🌸", color: "#F4F1FD" };
// }

// /**
//  * getLifeStageDetail(stageKey)
//  * Returns full stage object { id, name, age, development, care, conditions[], focus[] }
//  * from womenhealth.json → lifeStages
//  */
// export function getLifeStageDetail(stageKey) {
//   return lifeStages?.[stageKey] || null;
// }

// // ── Label formatter ──────────────────────────────────────────────────────────

// /**
//  * formatStageLabel("matureReproductive") => "Mature Reproductive"
//  */
// export function formatStageLabel(stage = "") {
//   return stage
//     .replace(/([A-Z])/g, " $1")
//     .replace(/^./, s => s.toUpperCase())
//     .trim();
// }

// // ── Question visibility (driven purely by resolved stage keys) ───────────────

// /**
//  * getVisibleQuestions(stages)
//  * Returns filtered + sequentially renumbered question list
//  * based on resolved stage keys from womenhealth.json
//  */
// export function getVisibleQuestions(stages = []) {
//   const has = key => stages.includes(key);

//   const isAdolescent         = has("adolescence");
//   const isYoungAdult         = has("youngAdult");
//   const isMatureReproductive = has("matureReproductive");
//   const isPeri               = has("perimenopause");
//   const isMenopause          = has("menopause");
//   const isPostMenopause      = has("postmenopause");
//   const isGeriatric          = has("geriatric");

//   // Visibility rules
//   const showPregnancy      = isMatureReproductive || (isYoungAdult && !isAdolescent);
//   const showTryingPregnant = isMatureReproductive;
//   const showDelivery       = isMatureReproductive || (isYoungAdult && !isAdolescent);
//   const showMenopause      = isPeri || isMenopause || isPostMenopause || isGeriatric;
//   const showLMP            = !isMenopause && !isPostMenopause && !isGeriatric;

//   const ALL = [
//     {
//       key:  "periods_started",
//       q:    "Have your periods started?",
//       desc: "Helps us understand your reproductive stage",
//       type: "yesno",
//       show: true,
//     },
//     {
//       key:  "currently_pregnant",
//       q:    "Are you currently pregnant?",
//       desc: "Helps us understand your reproductive stage",
//       type: "yesno",
//       show: showPregnancy,
//     },
//     {
//       key:  "trying_pregnant",
//       q:    "Are you trying to become pregnant?",
//       desc: "Helps us provide the right guidance",
//       type: "yesno",
//       show: showTryingPregnant,
//     },
//     {
//       key:  "menopause",
//       q:    "Have you reached menopause?",
//       desc: "Helps us tailor recommendations",
//       type: "yesno",
//       show: showMenopause,
//     },
//     {
//       key:  "lmp",
//       q:    "Last menstrual period (LMP)",
//       desc: "First day of your last period",
//       type: "date",
//       show: showLMP,
//     },
//     {
//       key:  "delivered_recently",
//       q:    "Have you delivered recently?",
//       desc: "Helps us understand your postpartum needs",
//       type: "yesno",
//       show: showDelivery,
//     },
//     {
//       key:  "last_delivery",
//       q:    "When was your last delivery?",
//       desc: "Helps us tailor your postpartum care",
//       type: "date",
//       show: showDelivery,
//     },
//   ];

//   // Filter visible + renumber sequentially
//   let num = 1;
//   return ALL.filter(q => q.show).map(q => ({ ...q, num: num++ }));
// }

// // ── localStorage helpers (for Entryreasonscreen.jsx compat) ─────────────────

// /**
//  * getEntryReasonJourney()
//  * Reads patientPersona from localStorage, resolves stages, returns journey.
//  * Used by Entryreasonscreen.jsx which reads from localStorage directly.
//  */
// export function getEntryReasonJourney() {
//   try {
//     const persona  = JSON.parse(localStorage.getItem("patientPersona") || "{}");
//     const age      = persona.age_group || persona.ageGroup || persona.age || "";
//     const marital  = persona.maritalStatus || persona.marital_status || "";
//     const stages   = getLifeStages(age, marital);
//     const stageKey = stages[0] || "youngAdult";
//     const journey  = getEntryReasons(stages);
//     return { stageKey, stageKeys: stages, journey, ageGroup: age, marital };
//   } catch {
//     return {
//       stageKey:  "youngAdult",
//       stageKeys: ["youngAdult"],
//       journey:   entryReasons["youngAdult"],
//       ageGroup:  "",
//       marital:   "",
//     };
//   }
// }

// /**
//  * saveEntryReasons(stageKey, selectedValues, journey)
//  * Persists chosen entry reasons back to localStorage patientPersona.
//  */
// export function saveEntryReasons(stageKey, selectedValues, journey) {
//   try {
//     const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
//     const selectedOptions = (journey?.options || []).filter(o =>
//       selectedValues.includes(o.value)
//     );
//     localStorage.setItem(
//       "patientPersona",
//       JSON.stringify({
//         ...existing,
//         lifeStageKey: stageKey,
//         journeyTitle: journey?.journeyTitle || "",
//         entryReasons: selectedValues,
//         entryRoutes:  selectedOptions.map(o => o.route),
//         savedAt:      Date.now(),
//       })
//     );
//   } catch (err) {
//     console.error("saveEntryReasons error:", err);
//   }
// }
// src/components/Reusablesteps/Resolvelifestage.js
//
// Reads from:
//   womenhealth.json  — full life stage definitions + entryReasons (rich version)
//   agedata.json      — ageMaritalToLifeStages mapping + entryReasons (alternate)
//
// We use womenhealth.json as the PRIMARY source since it has
// both ageMaritalToLifeStages AND entryReasons in one file.
//
// lifeStageQuestions (the actual question text/type/visibility rules) now
// live in CareJourney.json → screens.lifeStageQuestions, edited via the
// CareJourneyEditor dashboard. getVisibleQuestions() below reads that map
// instead of a hardcoded list, so dashboard edits actually take effect.

import WOMEN_HEALTH from "../../womenhealth.json";

const { ageMaritalToLifeStages, entryReasons, lifeStages, lifeStageEmoji } = WOMEN_HEALTH;

// ── Normalizers ──────────────────────────────────────────────────────────────

const AGE_MAP = {
  "10–14 years": "18–25",
  "15–19 years": "18–25",
  "20–25 years": "18–25",
  "26–35 years": "26–35",
  "36–45 years": "36–45",
  "46–55 years": "46–55",
  "55–64 years": "56+",
  "65+ years":   "56+",
};

const MARITAL_ALLOWED = ["Single", "Married", "Divorced", "Prefer not to say"];

export const normalizeAge     = (raw = "") => AGE_MAP[raw?.trim()] || null;
export const normalizeMarital = (raw = "") =>
  MARITAL_ALLOWED.includes(raw) ? raw : "Prefer not to say";

// ── Core stage resolver ──────────────────────────────────────────────────────

/**
 * getLifeStages(age, marital)
 * Looks up womenhealth.json → ageMaritalToLifeStages
 * Returns array of stage keys e.g. ["adolescence", "youngAdult"]
 */
export function getLifeStages(age, marital) {
  const ageKey     = normalizeAge(age);
  const maritalKey = normalizeMarital(marital);
  if (!ageKey) return ["youngAdult"];
  const byAge = ageMaritalToLifeStages[ageKey] || {};
  return (
    byAge[maritalKey] ||
    byAge["Prefer not to say"] ||
    ["youngAdult"]
  );
}

// ── Entry reasons ────────────────────────────────────────────────────────────

/**
 * getEntryReasons(stages)
 * Returns journey object { journeyTitle, screenTitle, options[] }
 * for the primary (first) stage key from womenhealth.json → entryReasons
 */
export function getEntryReasons(stages = []) {
  const primary = stages[0] || "youngAdult";
  return entryReasons[primary] || entryReasons["youngAdult"];
}

// ── Life stage metadata ──────────────────────────────────────────────────────

/**
 * getLifeStageMeta(stageKey)
 * Returns { emoji, color } for a stage key from womenhealth.json → lifeStageEmoji
 */
export function getLifeStageMeta(stageKey) {
  return lifeStageEmoji?.[stageKey] || { emoji: "🌸", color: "#F4F1FD" };
}

/**
 * getLifeStageDetail(stageKey)
 * Returns full stage object { id, name, age, development, care, conditions[], focus[] }
 * from womenhealth.json → lifeStages
 */
export function getLifeStageDetail(stageKey) {
  return lifeStages?.[stageKey] || null;
}

// ── Label formatter ──────────────────────────────────────────────────────────

/**
 * formatStageLabel("matureReproductive") => "Mature Reproductive"
 */
export function formatStageLabel(stage = "") {
  return stage
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, s => s.toUpperCase())
    .trim();
}

// ── Question visibility (data-driven, reads from CareJourney.json) ───────────

/**
 * evaluateVisibleWhen(conditions, answers)
 * conditions: array of { key, equals?, notEquals? } — all must pass (AND).
 * An empty/omitted array means "no answer-based restriction".
 */
function evaluateVisibleWhen(conditions = [], answers = {}) {
  if (!conditions || conditions.length === 0) return true;
  return conditions.every(cond => {
    const actual = answers[cond.key];
    if (cond.equals !== undefined && actual !== cond.equals) return false;
    if (cond.notEquals !== undefined && actual === cond.notEquals) return false;
    return true;
  });
}

/**
 * isQuestionVisible(q, stages, answers)
 * q.showForStages: array of stage keys this question applies to.
 *   Empty/omitted = visible for every stage.
 * q.visibleWhen: array of conditions against other answers (see above).
 */
function isQuestionVisible(q, stages = [], answers = {}) {
  const stageOk =
    !q.showForStages || q.showForStages.length === 0 || q.showForStages.some(s => stages.includes(s));
  if (!stageOk) return false;

  return evaluateVisibleWhen(q.visibleWhen, answers);
}

/**
 * getVisibleQuestions(stages, answers, questionsMap)
 * questionsMap: content.screens.lifeStageQuestions from CareJourney.json
 *   — a keyed object, e.g. { periods_started: { q, desc, type, order, showForStages, visibleWhen }, ... }
 *
 * Returns a sequentially-renumbered, order-sorted, filtered array of
 * { key, q, desc, type, visibleNum }.
 *
 * NOTE — signature changed from the old version:
 *   old:  getVisibleQuestions(stages)
 *   new:  getVisibleQuestions(stages, answers, questionsMap)
 * The extra params are required because visibility now depends on both
 * the current answers AND the dashboard-configured rules, not just stages.
 */
export function getVisibleQuestions(stages = [], answers = {}, questionsMap = {}) {
  const entries = Object.entries(questionsMap || {}).map(([key, q]) => ({ key, ...q }));

  const sorted = entries.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  let num = 1;
  return sorted
    .filter(q => isQuestionVisible(q, stages, answers))
    .map(q => ({ ...q, visibleNum: num++ }));
}

// ── localStorage helpers (for Entryreasonscreen.jsx compat) ─────────────────

/**
 * getEntryReasonJourney()
 * Reads patientPersona from localStorage, resolves stages, returns journey.
 * Used by Entryreasonscreen.jsx which reads from localStorage directly.
 */
export function getEntryReasonJourney() {
  try {
    const persona  = JSON.parse(localStorage.getItem("patientPersona") || "{}");
    const age      = persona.age_group || persona.ageGroup || persona.age || "";
    const marital  = persona.maritalStatus || persona.marital_status || "";
    const stages   = getLifeStages(age, marital);
    const stageKey = stages[0] || "youngAdult";
    const journey  = getEntryReasons(stages);
    return { stageKey, stageKeys: stages, journey, ageGroup: age, marital };
  } catch {
    return {
      stageKey:  "youngAdult",
      stageKeys: ["youngAdult"],
      journey:   entryReasons["youngAdult"],
      ageGroup:  "",
      marital:   "",
    };
  }
}

/**
 * saveEntryReasons(stageKey, selectedValues, journey)
 * Persists chosen entry reasons back to localStorage patientPersona.
 */
export function saveEntryReasons(stageKey, selectedValues, journey) {
  try {
    const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
    const selectedOptions = (journey?.options || []).filter(o =>
      selectedValues.includes(o.value)
    );
    localStorage.setItem(
      "patientPersona",
      JSON.stringify({
        ...existing,
        lifeStageKey: stageKey,
        journeyTitle: journey?.journeyTitle || "",
        entryReasons: selectedValues,
        entryRoutes:  selectedOptions.map(o => o.route),
        savedAt:      Date.now(),
      })
    );
  } catch (err) {
    console.error("saveEntryReasons error:", err);
  }
}